var render, staticRenderFns
import script from "./stylesheet-restaurant.vue?vue&type=script&lang=coffee"
export * from "./stylesheet-restaurant.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports